import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { getXsrfToken } from "../../Store/Security/Actions";
import Modal from "react-modal";
import { Translate, I18n } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
import { addAddress, editAddress } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { updateAddAddressModalState, setAddAddressModalData } from "../../Store/Modals/Actions";
import { getCountries, getStates } from "../../Store/Checkout/Actions";
Modal.setAppElement("#react-app");

class AddressModal extends Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.renderCountries = this.renderCountries.bind(this);
        this.renderStates = this.renderStates.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
    }

    componentWillMount() {
        const { getCountries, getStates, countries, states } = this.props;

        if (!countries || countries.length === 0) {
            getCountries(countries => {
                if (!states || states.length === 0) {
                    getStates(countries[0].countryId);
                }
            });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const { change, addAddressModalData, countries, states } = nextProps;

        if (Object.keys(addAddressModalData).length > 0) {
            change("City", addAddressModalData.city);
            change("Address1", addAddressModalData.address1);
            change("Address2", addAddressModalData.address2);
            change("ZipPostalCode", addAddressModalData.zipPostalCode);

            if (!countries || countries.length === 0) {
                change("CountryId", addAddressModalData.countryId);
            }

            if (!states || states.length === 0) {
                change("StateId", addAddressModalData.stateProvinceId);
            }
        }
    }

    openModal() {
        this.props.updateAddAddressModalState(true);
    }

    closeModal() {
        const { reset, untouch, updateAddAddressModalState, setAddAddressModalData } = this.props;

        reset();
        untouch("City");
        untouch("Address1");
        untouch("Address2");
        untouch("ZipPostalCode");
        updateAddAddressModalState(false);
        setAddAddressModalData({});
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = touched && error ? "has-error" : "";

        return (
            <div className={className}>
                <input type={field.type} placeholder={field.placeholder} {...field.input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderCountries() {
        const { countries } = this.props;

        if (countries.length > 0) {
            return _.map(countries, country =>
                <option key={country.countryId} value={country.countryId}>{country.countryName}</option>
            );
        }
    }

    renderStates() {
        const { states } = this.props;

        if (states.length > 0) {
            return _.map(states, state =>
                <option key={state.stateId} value={state.stateId}>{state.stateName}</option>
            );
        }
    }

    onCountryChange(countryId) {
        const { getStates } = this.props;

        getStates(countryId);
    }

    renderErrors() {
        if (this.props.addressStatus.response) {
            const { response: { data } } = this.props.addressStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return <div className="col-md-12">
                    <div className="alert bg--error" style={{ marginBottom: 0 }}>
                        <div className="alert__body">
                            <span>{data}</span>
                        </div>
                    </div>
                </div>;
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, addAddress, editAddress, reset, toggleBlockingStatus, updateAddAddressModalState, addAddressModalData, setAddAddressModalData } = this.props;

        toggleBlockingStatus(true);

        let countryId = values.CountryId;
        let stateId = values.StateId;
        let countryName = null;
        let stateName = null;

        const countryElement = document.getElementsByName("CountryId")[0];
        const stateElement = document.getElementsByName("StateId")[0];

        if (!values.CountryId && countryElement) {
            countryId = countryElement.value;
        }

        if (!values.StateId && stateElement) {
            stateId = stateElement.value;
        }

        if (countryElement) {
            countryName = countryElement.options[countryElement.selectedIndex].text;
        }

        if (stateElement) {
            stateName = stateElement.options[stateElement.selectedIndex].text;
        }

        let obj;

        getXsrfToken(({ token }) => {
            if (Object.keys(addAddressModalData).length > 0) {
                obj = {
                    ...addAddressModalData,
                    __RequestVerificationToken: token,
                    CountryId: countryId,
                    CountryName: countryName,
                    StateProvinceId: stateId,
                    StateProvinceName: stateName,
                    City: Utilities.toTitleCase(values.City).trim(),
                    Address1: Utilities.toTitleCase(values.Address1).trim(),
                    Address2: Utilities.toTitleCase(values.Address2 || "").trim(),
                    ZipPostalCode: values.ZipPostalCode.trim()
                };

                editAddress(obj, () => {
                    reset();
                    toggleBlockingStatus(false);
                    updateAddAddressModalState(false);
                    setAddAddressModalData({});
                });
            } else {
                obj = {
                    __RequestVerificationToken: token,
                    CountryId: countryId,
                    CountryName: countryName,
                    StateProvinceId: stateId,
                    StateProvinceName: stateName,
                    City: Utilities.toTitleCase(values.City).trim(),
                    Address1: Utilities.toTitleCase(values.Address1).trim(),
                    Address2: Utilities.toTitleCase(values.Address2 || "").trim(),
                    ZipPostalCode: values.ZipPostalCode.trim()
                };

                addAddress(obj, () => {
                    reset();
                    toggleBlockingStatus(false);
                    updateAddAddressModalState(false);
                    setAddAddressModalData({});
                });
            }
        });
    }

    render() {
        const { addAddressModalOpen, handleSubmit, countries, states, pristine, submitting, addAddressModalData } = this.props;

        return (
            <Modal
                isOpen={addAddressModalOpen}
                onRequestClose={this.closeModal}
                contentLabel="add address alert"
                className="modal-content"
                overlayClassName="modal-container add-address-modal modal-active"
            >
                <div className="modal-body">
                    <div className="feature feature-1">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <h3><Translate value={Object.keys(addAddressModalData).length > 0 ? "address.edit" : "address.add"} /></h3>
                                <form id="address-form" style={{ marginTop: 0 }} onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label><Translate value="address.country" /></label>
                                                    <div className="input-select">
                                                        <Field name="CountryId" value={countries.length > 0 ? countries[0].id : 0} component="select" onChange={e => this.onCountryChange(e.target.value)}>
                                                            {this.renderCountries()}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label><Translate value="address.state" /></label>
                                                    <div className="input-select">
                                                        <Field name="StateId" value={states.length > 0 ? states[0].id : 0} component="select" >
                                                            {this.renderStates()}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12" style={{ marginTop: 10 }}>
                                                    <Field
                                                        name="City"
                                                        type="text"
                                                        label={I18n.t("address.city")}
                                                        placeholder={I18n.t("address.city")}
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="Address1"
                                                        type="text"
                                                        label={I18n.t("address.address1")}
                                                        placeholder={I18n.t("address.address1")}
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="Address2"
                                                        type="text"
                                                        label={I18n.t("address.address2")}
                                                        placeholder={I18n.t("address.address2")}
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <Field
                                                        name="ZipPostalCode"
                                                        type="text"
                                                        label={I18n.t("address.postalCode")}
                                                        placeholder={I18n.t("address.postalCode")}
                                                        component={this.renderTextField}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {this.renderErrors()}
                                        <div className="col-12 create-button-col">
                                            <button type="submit" className="btn btn--primary type--uppercase" disabled={pristine || submitting}><Translate value={Object.keys(addAddressModalData).length > 0 ? "address.edit" : "address.add"} /></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        xsrfToken: state.xsrfToken,
        userInfo: state.userInfo,
        addressStatus: state.addressStatus,
        addAddressModalOpen: state.addAddressModalOpen,
        addAddressModalData: state.addAddressModalData,
        countries: state.countries,
        states: state.states,
        addresses: state.addresses
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addAddress: addAddress,
        editAddress: editAddress,
        toggleBlockingStatus: toggleBlockingStatus,
        updateAddAddressModalState: updateAddAddressModalState,
        getCountries: getCountries,
        getStates: getStates,
        setAddAddressModalData: setAddAddressModalData
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.City) {
        errors.City = I18n.t("validation.address.city.required");
    }
    if (!values.Address1) {
        errors.Address1 = I18n.t("validation.address.address1.required");
    }
    if (!values.ZipPostalCode) {
        errors.ZipPostalCode = I18n.t("validation.address.postalCode.required");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "AddAddress"
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(AddressModal))
);